export const setAuthToken = async (user) => {
  const currentUser = {
    email: user.email,
  };
  
  try {
    const response = await fetch(`https://mirai-server.vercel.app/user/${user?.email}`, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(currentUser),
    });

    const data = await response.json();
    if (data.token) {
      // Save token in LocalStorage
      localStorage.setItem('aircnc-token', data.token);
      console.log('Token saved to local storage:', data.token);
    } else {
      console.error('Failed to retrieve token from response.');
    }
  } catch (error) {
    console.error('Error setting auth token:', error);
  }
};

export const saveBooking = bookingData => {
  // Post method fetch
  return fetch(`https://mirai-server.vercel.app/bookings`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${localStorage.getItem('aircnc-token')}`,
    },
    body: JSON.stringify(bookingData),
  })
}
